import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VendorsComponent } from './vendors/vendors.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
// import { UsersComponent } from './users/users.component';
import { AuthguardService } from './shared/services/authguard.service';
import { OrganizationListComponent } from './organizations/organization-list/organization-list.component';
import { ManageListsComponent } from './manage-lists/manage-lists.component';
import { ActivityListComponent } from './activities/activity-list/activity-list.component';
import { ContractListComponent } from './contracts/contract-list/contract-list.component';
// Loading modules lazily with AuthGuards.
// If ExpectedRoles are not defined in route, Anonymous user can access those routes
const routes: Routes = [
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{
		path: 'organizations',
		loadChildren: './organizations/organizations.module#OrganizationsModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'contacts',
		loadChildren: './contacts/contacts.module#ContactsModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'opportunities',
		loadChildren: './opportunities/opportunities.module#OpportunityModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'leads',
		loadChildren: './leads/lead.module#LeadModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'activities',
		loadChildren: './activities/activity.module#ActivityModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'vendors',
		loadChildren: './vendors/vendor.module#VendorModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'reports',
		loadChildren: './reports/report.module#ReportModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'users',
		loadChildren: './users/user.module#UserModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'contracts',
		// component: ContractListComponent,
		loadChildren: './contracts/contract-list.module#ContractListModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'pages-and-privileges',
		loadChildren: './pages-and-privileges/pages-and-privileges.module#PagesAndPrivilegesModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'manage-lists',
		component: ManageListsComponent,
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'user-roles-and-privileges',
		loadChildren: './user-roles-and-privileges/user-roles-and-privileges.module#UserRolesAndPrivilegesModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'purchase-orders',
		loadChildren: './purchase-orders/purchase-orders.module#PurchaseOrdersModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'shipping',
		loadChildren: './shipping/shipping.module#ShippingModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'pobook',
		loadChildren: './pobook/pobook.module#PobookModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'products',
		loadChildren: './products/products.module#ProductsModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	},
	{
		path: 'client',
		loadChildren: './client-view/client-view.module#ClientViewModule',
		canActivate: [AuthguardService],
		data: {
			expectedRole: ['admin', 'user']
		}
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts